module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subcat-score-column-wrapper"
  }, _vm._l((_vm.subcategories), function(subcategory, index) {
    return _c('subcat-row', {
      key: subcategory.name,
      attrs: {
        "subcategory": subcategory,
        "subcatColumnA": _vm.columnAsubcats[index],
        "subcatColumnB": _vm.columnBsubcats[index]
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f887b5b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/comparison/SubcategoryScores.vue
// module id = 536
// module chunks = 1